<template>
  <van-list v-model="loading" :finished="finished" @load="loadMore">
    <ul>
      <EquipmentDemo v-for="(item, index) in pageList" :key="index" :msg="item"></EquipmentDemo>
    </ul>
  </van-list>
</template>

<script>
import { mapGetters } from 'vuex';
import { Indicator } from 'mint-ui';
import EquipmentDemo from '../components/EquipmentDemo';

export default {
  data() {
    return{
      pageList: [],
      pageIndex: 1,
      pageTotal: 0,
      loading: false,
      finished: false,
    }
  },
  methods: {
    getList() {  // 获取列表
      Indicator.open('加载中...');
      setTimeout(() => {
        Indicator.close();
      }, 5000);
      this.$http.post(`${this.URL_PREFIX}/app/get/facilities/rent/list`, {
        parkId: this.currentParkId,
        serviceId: this.$route.params.serviceId,
        currPage: this.pageIndex,
        pageRows: 10,
      }).then((response) => {
        const res = response.data;
        Indicator.close();
        if (res.resCode === '10000') {
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.pageList = this.pageList.concat(tempArr);
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          this.finished = this.pageList.length >= this.pageTotal ? true : false;
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
    loadMore() {
      if (this.pageList.length >= this.pageTotal) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      this.getList();
    }
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  components: {
    EquipmentDemo, 
  },
  watch: {
    $route() {
      this.pageList = [];
      this.pageIndex = 1;
      this.getList();
    },
  },
}
</script>

<style lang="scss" scoped>
.van-list{
  background: #ece9e9;
}

ul {
  padding-bottom: .32rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/child/Equipment.vue